import React from "react";
import Svg, { Path, Defs, Rect, G, ClipPath, Circle } from "react-native-svg";

export default function SendIcon(props) {
  const { onPress } = props;
  const color = props.color || "#ABADB3";

  return (
    <Svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      cursor="pointer"
      onPress={onPress}
    >
      <G clipPath="url(#clip0_13203_32592)">
        <Circle cx="12.4152" cy="12.0245" r="12.0148" fill={color} />
        <Path
          d="M7.41474 17.7441L19.5906 12.5234L7.41474 7.30273L7.40894 11.3633L16.1101 12.5234L7.40894 13.6836L7.41474 17.7441Z"
          fill="white"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_13203_32592">
          <Rect
            width="24.0296"
            height="24.0296"
            fill="white"
            transform="translate(0.400391 0.00976562)"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
}
